import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { KitComponent } from '@/types/fulfill/inventory';

interface KitThumbnailStackProps {
  components: KitComponent[];
}

const MAX_VISIBLE_THUMBNAILS = 3;
const THUMBNAIL_SIZE = 28;
const THUMBNAIL_OFFSET_X = 10;
const THUMBNAIL_OFFSET_Y = 7;

const KitThumbnailStack = ({ components }: KitThumbnailStackProps) => {
  const visibleComponents = components.slice(0, MAX_VISIBLE_THUMBNAILS);
  const extraCount = components.length - visibleComponents.length;

  return (
    <Box sx={{ position: 'relative', width: 50, height: 50 }}>
      {visibleComponents.map((component, index) => (
        <Box
          key={component.sku}
          component="img"
          src={component.thumbnail}
          alt={component.name}
          sx={{
            position: 'absolute',
            left: index * THUMBNAIL_OFFSET_X,
            top: index * THUMBNAIL_OFFSET_Y,
            width: THUMBNAIL_SIZE,
            height: THUMBNAIL_SIZE,
            borderRadius: '0.5rem',
            objectFit: 'cover',
            border: '2px solid white',
            boxShadow: '0 1px 3px rgba(18, 52, 74, 0.25)',
            zIndex: visibleComponents.length - index,
          }}
        />
      ))}
      {extraCount > 0 && (
        <Box
          sx={{
            position: 'absolute',
            right: -2,
            bottom: -2,
            minWidth: 18,
            height: 18,
            px: 0.4,
            borderRadius: '999px',
            backgroundColor: (theme) => theme.palette.secondary.main,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: visibleComponents.length + 1,
          }}
        >
          <Typography
            variant="caption"
            sx={{ fontSize: '0.6rem', fontWeight: 'bold', lineHeight: 1, color: 'white' }}
          >
            +{extraCount}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default KitThumbnailStack;
